import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import { downloadLogsWashboardDevice } from 'api/admin/washboard/washboard';

type DownloadLogsWashboardDeviceVariables = {
  deviceId: number;
  deviceName: string;
  skipToast?: boolean;
};

export const useDownloadLogsWashboardDevice = () => {
  return useMutation<unknown, AxiosError<{ error: string }>, DownloadLogsWashboardDeviceVariables>({
    mutationFn: async ({ deviceId }: DownloadLogsWashboardDeviceVariables) => {
      return downloadLogsWashboardDevice(deviceId);
    },
    onSuccess: (_, variables) => {
      if (!variables.skipToast) {
        toaster('Log download triggered successfully', {
          icon: '✅',
        });
      }
    },
    onError: (error, variables) => {
      Sentry.captureException(error);
      if (!variables.skipToast) {
        const errorMessage = error?.response?.data?.error ?? 'Failed to trigger log download';
        const message = `${errorMessage} (${variables?.deviceName})`;
        toaster(message, {
          icon: '❌',
        });
      }
    },
  });
};
